// required so we don't have to do require('pusher').default etc.
module.exports = require('./pingerchips').default;
